import { createContext, use } from "react";
import { useSnapshot } from "valtio/react";
import type { GlobalState, GlobalStateSetters } from "./types";

export const GlobalStateContext = createContext<
    (GlobalState & GlobalStateSetters) | undefined
>(undefined);

export const useGlobalState = () => {
    const globalState = use(GlobalStateContext);

    if (globalState === undefined) {
        throw new Error(
            "useGlobalState() was called before GlobalStateContext value was properly initialized.",
        );
    }

    return useSnapshot(globalState);
};
